__turbopack_context__.v({
  "active": "Navbar-module__cRh5nW__active",
  "container": "Navbar-module__cRh5nW__container",
  "desktopCta": "Navbar-module__cRh5nW__desktopCta",
  "desktopNav": "Navbar-module__cRh5nW__desktopNav",
  "hamburger": "Navbar-module__cRh5nW__hamburger",
  "header": "Navbar-module__cRh5nW__header",
  "logo": "Navbar-module__cRh5nW__logo",
  "mobileCta": "Navbar-module__cRh5nW__mobileCta",
  "mobileMenu": "Navbar-module__cRh5nW__mobileMenu",
  "mobileNav": "Navbar-module__cRh5nW__mobileNav",
  "mobileNavLink": "Navbar-module__cRh5nW__mobileNavLink",
  "mobileToggle": "Navbar-module__cRh5nW__mobileToggle",
  "navLink": "Navbar-module__cRh5nW__navLink",
  "open": "Navbar-module__cRh5nW__open",
  "rightActions": "Navbar-module__cRh5nW__rightActions",
  "scrolled": "Navbar-module__cRh5nW__scrolled",
});
